import React from 'react';

const ErrorMessage = ({ message, onRetry }) => {
  const isKeyAlreadyChanged = message.includes('уже был обработан ранее');
  
  return (
    <div className="card p-6 md:p-8">
      <div className="text-center mb-6 md:mb-8">
        <div className={`w-14 h-14 md:w-16 md:h-16 ${isKeyAlreadyChanged ? 'bg-blue-100' : 'bg-red-100'} rounded-full flex items-center justify-center mx-auto mb-4`}>
          {isKeyAlreadyChanged ? (
            <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          ) : (
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          )}
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-2">
          {isKeyAlreadyChanged ? 'Заказ уже обработан' : 'Ошибка при проверке заказа'}
        </h2>
        <p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6 px-2">
          {message}
        </p>
      </div>

        {isKeyAlreadyChanged ? (
          <div className="bg-blue-50 rounded-lg p-4 mb-6">
            <div className="flex items-start">
              <svg className="w-5 h-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div>
                <h3 className="text-sm font-medium text-blue-900 mb-2">
                  Что это означает?
                </h3>
                <p className="text-sm text-blue-700 mb-3">
                  Этот заказ уже был использован для получения подписки ранее. Каждый заказ можно использовать только один раз для восстановления.
                </p>
                <h3 className="text-sm font-medium text-blue-900 mb-2">
                  Что делать?
                </h3>
                <ul className="text-sm text-blue-700 space-y-1">
                  <li>• Проверьте историю восстановлений ниже</li>
                  <li>• Если нужна новая подписка, оформите новый заказ</li>
                  <li>• Обратитесь в поддержку при необходимости</li>
                </ul>
              </div>
            </div>
          </div>
        ) : (
        <div className="space-y-4 md:space-y-6">
          <div className="bg-red-50 rounded-lg p-3 md:p-4">
            <div className="flex items-start">
              <svg className="w-5 h-5 text-red-600 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div>
                <h3 className="text-sm font-medium text-red-900 mb-1">
                  Возможные причины
                </h3>
                <ul className="text-sm text-red-700 space-y-1">
                  <li>• Неверный номер заказа</li>
                  <li>• Заказ не найден в системе</li>
                  <li>• Проблемы с подключением к серверу</li>
                  <li>• Заказ уже был обработан ранее</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 rounded-lg p-3 md:p-4">
            <div className="flex items-start">
              <svg className="w-5 h-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div>
                <h3 className="text-sm font-medium text-blue-900 mb-1">
                  Что делать?
                </h3>
                <ul className="text-sm text-blue-700 space-y-1">
                  <li>• Проверьте правильность номера заказа</li>
                  <li>• Убедитесь, что заказ был оформлен на Яндекс Маркете</li>
                  <li>• Попробуйте еще раз через несколько минут</li>
                  <li>• Обратитесь в поддержку, если проблема повторяется</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
          <button
            onClick={onRetry}
            className="btn-primary flex-1 text-sm md:text-base"
          >
            <svg className="w-4 h-4 md:w-5 md:h-5 mr-2 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Попробовать снова
          </button>
          <button
            onClick={() => window.location.reload()}
            className="btn-secondary flex-1 text-sm md:text-base"
          >
            <svg className="w-4 h-4 md:w-5 md:h-5 mr-2 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Обновить страницу
          </button>
        </div>
    </div>
  );
};

export default ErrorMessage;
